var _defs, _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
;

var SvgRefscout = function SvgRefscout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 32,
    viewBox: "0 0 24 32"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "refscout_svg__refscout_svg__linearGradient38529",
    x1: 94,
    x2: 113,
    y1: -103.5,
    y2: -103.5,
    gradientTransform: "translate(-89 108)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1dcafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32a4e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "refscout_svg__refscout_svg__linearGradient31155",
    x1: 94,
    x2: 113,
    y1: -103.5,
    y2: -103.5,
    gradientTransform: "translate(-94 114)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#30a6e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#207bdd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "refscout_svg__refscout_svg__linearGradient118856",
    x1: -14.352,
    x2: -10.258,
    y1: 2.58,
    y2: 8.917,
    gradientTransform: "matrix(1.2041 0 0 1.3611 34.656 6.863)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd14f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e09f00"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eaa62b",
    d: "M9 10.5h5v1H9z",
    paintOrder: "markers fill stroke"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21a6ed",
    d: "M6 16.5h5v1H6z",
    paintOrder: "markers fill stroke"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#refscout_svg__refscout_svg__linearGradient38529)",
    d: "M16 0c-.554 0-1 .446-1 1v2.75h-5V3c0-.554-.446-1-1-1H6c-.554 0-1 .446-1 1v3c0 .554.446 1 1 1h3c.554 0 1-.446 1-1v-.75h5V8c0 .554.446 1 1 1h7c.554 0 1-.446 1-1V1c0-.554-.446-1-1-1z",
    paintOrder: "markers fill stroke",
    transform: "translate(0 6.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#refscout_svg__refscout_svg__linearGradient31155)",
    d: "M11 6c-.554 0-1 .446-1 1v2.75H5V9c0-.554-.446-1-1-1H1c-.554 0-1 .446-1 1v3c0 .554.446 1 1 1h3c.554 0 1-.446 1-1v-.75h5V14c0 .554.446 1 1 1h7c.554 0 1-.446 1-1V7c0-.554-.446-1-1-1z",
    paintOrder: "markers fill stroke",
    transform: "translate(0 6.5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#refscout_svg__refscout_svg__linearGradient118856)",
    d: "M18 9a.695.786 0 00-.602.393l-2.755 5.392-1.55 3.035a.695.786 0 00.602 1.18h8.61a.695.786 0 00.601-1.18l-2.754-5.392-1.55-3.035A.695.786 0 0018 9zm0 3c.277 0 .5.223.5.5v2a.499.499 0 11-1 0v-2c0-.277.223-.5.5-.5z",
    paintOrder: "markers stroke fill",
    transform: "translate(0 6.5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#242424",
    d: "M18 18.5c-.277 0-.5.223-.5.5v2a.499.499 0 101 0v-2c0-.277-.223-.5-.5-.5zm-.025 4a.5.5 0 10.025 0h-.025z",
    paintOrder: "markers fill stroke"
  })));
};

;
export default SvgRefscout;